module.exports = __webpack_public_path__ + "img/hohlsaum_hellelfenbein_ral1015.092353f9.jpg";